import React from 'react'
import PropTypes from 'prop-types'
import {
  Link, PDFLink, Prezi, Wistia, Snapshot,
  FileContainer, Youtube, OembedContainer,
  Image, LinkedinPost, Google, Vidyard, Brightcove,
  NewTab, FacebookVideo, BrightTalk, LinkContainer,
  Article
} from './types'
import { getItemType } from 'shared/Components/ItemContent/config'

import './style.css.scss'

const RENDERERS = {
  link: LinkContainer,
  pdf: PDFLink,
  prezi: Prezi,
  wistia: Wistia,
  snapshot: Snapshot,
  facebook_video: FacebookVideo,
  youtube: Youtube,
  oembed: OembedContainer,
  video: Link,
  vidyard: Vidyard,
  linkedin_post: LinkedinPost,
  google: Google,
  newTab: NewTab,
  image: Image,
  file: FileContainer,
  box: FileContainer,
  brighttalk: BrightTalk,
  brightcove: Brightcove,
  article: Article
}

const ItemRenderer = (props) => {
  const type = getItemType(props.item)
  const SpecificRenderer = props.item.open_in_new_tab ? RENDERERS.newTab : RENDERERS[type]

  return (
    <SpecificRenderer
      item={props.item}
      onClick={props.onClick}
      contentItemId={props.contentItemId}
      requireSsl={props.requireSsl}
      onItemContentAction={props.onItemContentAction} />
  )
}

ItemRenderer.propTypes = {
  item: PropTypes.object.isRequired,
  contentItemId: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  requireSsl: PropTypes.bool
}

export default ItemRenderer